export function FiltersDiv({ ingredienti, categorie, tags, credits }) {
  const ingSplitted=ingredienti.split(',');
  const catSplitted=categorie.split(',');
  const tagsSplitted=tags.split(',');
  const creditsSplitted=credits.split(',');
  const toggleIngredientsFilter = function  (e) {
    const spittedValue = e.target.value.split("|");
    window.searchFilterView["ingredients"] = [...window.searchFilterView["ingredients"]];
    const indexExcluded = window.excludedFilterView["ingredients"].indexOf(spittedValue[0]);
    if (indexExcluded > -1) {
      window.excludedFilterView["ingredients"].splice(indexExcluded, 1);
    } else {
      window.excludedFilterView["ingredients"].push(spittedValue[0]);
    }
    const index = window.searchFilterView["ingredients"].indexOf(spittedValue[0]);
    if (index > -1) { 
      window.searchFilterView["ingredients"].splice(index, 1); 
    } else {
      window.searchFilterView["ingredients"].push(spittedValue[0]); 
    }
    if (indexExcluded > -1 && index > -1) {
      window.excludedFilterView["ingredients"].push(spittedValue[0]);
    }

    var retVal = [];
    for (let i = 0; i < ingSplitted.length; i++) {
      const x = ingSplitted[i].split("|");
      if (window.searchFilterView["ingredients"].indexOf(x[0]) > -1) { 
        retVal.push({
          label:x[1],
          value: {id: x[0], label: x[1]}
        })
      }
    }
    window.ingredientsChange(retVal);
  }
  const toggleTagsFilter= function (e) {
    const spittedValue = e.target.value;
    window.searchFilterView["tags"] = [...window.searchFilterView["tags"]];
    const index = window.searchFilterView["tags"].indexOf(spittedValue);
    const indexExcluded = window.excludedFilterView["tags"].indexOf(spittedValue);
    if (indexExcluded > -1) {
      window.excludedFilterView["tags"].splice(indexExcluded, 1);
    } else {
      window.excludedFilterView["tags"].push(spittedValue);
    }
    if (indexExcluded > -1 && index > -1) {
      window.excludedFilterView["tags"].push(spittedValue);
    }
    if (index > -1) { 
      window.searchFilterView["tags"].splice(index, 1); 
    } else {
      window.searchFilterView["tags"].push(spittedValue); 
    }
    var retVal = {
      selected: !(window.searchFilterView["tags"].indexOf(e.target.value) > -1),
      value: e.target.value
    }
    window.tagsChange(retVal);
  }

  const toggleCreditsFilter= function (e) {
    const spittedValue = e.target.value;
    window.searchFilterView["credits"] = [...window.searchFilterView["credits"]];
    const index = window.searchFilterView["credits"].indexOf(spittedValue);
    const indexExcluded = window.excludedFilterView["credits"].indexOf(spittedValue);
    if (indexExcluded > -1) {
      window.excludedFilterView["credits"].splice(indexExcluded, 1);
    } else {
      window.excludedFilterView["credits"].push(spittedValue);
    }
    if (indexExcluded > -1 && index > -1) {
      window.excludedFilterView["credits"].push(spittedValue);
    }
    if (index > -1) { 
      window.searchFilterView["credits"].splice(index, 1); 
    } else {
      window.searchFilterView["credits"].push(spittedValue); 
    }
    var retVal = {
      value: e.target.value
    }
    window.creditChange(retVal);
  }

  const toggleBadgesFilter= function (e) {
    const spittedValue = e.target.value.split("|");
    window.searchFilterView["badges"] = [...window.searchFilterView["badges"]];
    const index = window.searchFilterView["badges"].indexOf(spittedValue[0]);
    const indexExcluded = window.excludedFilterView["badges"].indexOf(spittedValue[0]);
    if (indexExcluded > -1) {
      window.excludedFilterView["badges"].splice(indexExcluded, 1);
    } else {
      window.excludedFilterView["badges"].push(spittedValue[0]);
    }
    if (indexExcluded > -1 && index > -1) {
      window.excludedFilterView["badges"].push(spittedValue[0]);
    }
    if (index > -1) { 
      window.searchFilterView["badges"].splice(index, 1); 
    } else {
      window.searchFilterView["badges"].push(spittedValue[0]); 
    }
    var retVal = {
          label: spittedValue[1],
          value: spittedValue[0],
          retrieved: index > -1
    }
    window.badgesChange(retVal);
  }

  return ([
      <span className={`filter-div-span ${ingredienti.length > 0 ? "" : "hidden" }`}>
        { ingredienti.length > 0 ? 
        <>
        <div className="filter-div-img">
          <img height="45" key="ViewFiltriImg" src={`/images/filtri/ingredients.png`} alt="Icona Ingredienti" ></img>
        </div>
        <div>
          <h4 className="filter-div-h4">Ingredienti: </h4>
            <div key={'ingredienti12'} id="checklist">
              {
                ingSplitted.map((ele, i) =>
                  <>
                  <input id={"ingrediente" + i} type="checkbox" name="idIngredeinte" value={ele} 
                      checked={!window.searchFilterView["ingredients"].includes(ele.split("|")[0])} onChange={toggleIngredientsFilter}/>
                  <label htmlFor={"ingrediente" + i}>{ele.split("|")[1]}</label>
                  </>
              )}
            </div>
        </div>
        </>
        :
        <></>
      }
      </span>,
      <span className={`filter-div-span ${categorie.length > 0 ? "" : "hidden" }`}>
        { categorie.length > 0 ? 
        <>
        <div className="filter-div-img">
          <img height="45" key="ViewFiltriBadge" src={`/images/filtri/categories.png`} alt="Icona Badge" ></img>
        </div>
        <div>
          <h4 className="filter-div-h4">Categorie: </h4>
            <div key={'categorie12'} id="checklist">
              {
                catSplitted.map((ele, i) =>
                  <>
                  <input id={"categoria" + i} type="checkbox" name="badge" value={ele} 
                    checked={!window.searchFilterView["badges"].includes(ele.split("|")[0])} onChange={toggleBadgesFilter}/>

                  <label htmlFor={"categoria" + i}>{ele.split("|")[1]}</label>
                  </>
              )}
            </div>
        </div>
        </>
        :
        <></>
      }
      </span>,
      <span className={`filter-div-span ${tags.length > 0 ? "" : "hidden" }`}>
        { tags.length > 0 ? 
        <>
        <div className="filter-div-img">
          <img height="45" key="ViewFiltriTag" src={`/images/filtri/hashtag.png`} alt="Icona Tag" ></img>
        </div>
        <div>
          <h4 className="filter-div-h4">Tags: </h4>
          <div key={'tags12'} id="checklist">
            {
              tagsSplitted.map((ele, i) =>
                <>
                <input id={"tag" + i} type="checkbox" name="tag" value={ele}
                    checked={!window.searchFilterView["tags"].includes(ele)} onChange={toggleTagsFilter}/>
                <label htmlFor={"tag" + i}>{ele}</label>
                </>
            )}
          </div>
        </div>
        </>
        :
        <></>
      }
      </span>,
      <span className={`filter-div-span ${credits.length > 0 ? "" : "hidden" }`}>
        { credits.length > 0 ? 
        <>
        <div className="filter-div-img">
          <img height="45" key="ViewFiltriAutori" src={`/images/filtri/credits.png`} alt="Icona Autori" ></img>
        </div>
        <div>
          <h4 className="filter-div-h4">Autori: </h4>
            <div key={'autori12'} id="checklist">
              {
                creditsSplitted.map((ele, i) =>
                  <>
                  <input id={"autore" + i} type="checkbox" name="autore" value={ele}
                      checked={!window.searchFilterView["credits"].includes(ele)} onChange={toggleCreditsFilter}/>
                  <label htmlFor={"autore" + i}>{ele}</label>
                  </>
              )}
            </div>
        </div>
        </>
        :
        <></>
      }
      </span>
  ]);

}